export const cilSim = ["24 24","<path d='M18 1.875h-7.189c-0.001 0-0.003 0-0.004 0-0.413 0-0.787 0.168-1.057 0.439l-5.186 5.186c-0.271 0.27-0.439 0.644-0.439 1.057 0 0.001 0 0.003 0 0.004v-0 12.439c0.001 0.828 0.672 1.499 1.5 1.5h12.375c0.828-0.001 1.499-0.672 1.5-1.5v-17.625c-0.001-0.828-0.672-1.499-1.5-1.5h-0zM18 21h-12.375v-12.439l5.186-5.186h7.189z'></path><path d='M9.75 19.5h6.75v-9.375h-6.75zM11.25 11.625h3.75v6.375h-3.75z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-sim.js
// module id = null
// module chunks = 